import { render, staticRenderFns } from "./UIdesignproject.vue?vue&type=template&id=07dbdb3c"
import script from "./UIdesignproject.vue?vue&type=script&lang=js"
export * from "./UIdesignproject.vue?vue&type=script&lang=js"
import style0 from "./UIdesignproject.vue?vue&type=style&index=0&id=07dbdb3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports